//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PredictedBodyWeightARDS',
  data () {
    return {
      defaultJson:{
        "Height": "身高",
        "Predicted Weight": "体重预测值",
        "Target Vt (mL\/kg)": "目标潮气量（mL\/kg）"
      },
      form: {
        h:'',
        gender:'',
      },
      hasScore: false,
      disabled: false,
      state:'',
      targetVt1:'',
      targetVt2:'',
      vt:'--',
      dataList1:[
        {value:"0",name:'男'},
        {value:"1",name:'女'},
      ],
      dataList2:[
        {value:"1",name:'双肺'},
        {value:"2",name:'单肺'},
      ],
      dataList3:[
        {value:"6",name:'6'},
        {value:"7",name:'7'},
        {value:"8",name:'8'},
      ],
      dataList4:[
        {value:"4",name:'4'},
        {value:"5",name:'5'},
        {value:"6",name:'6'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.vt = '--'
        return '--'
      } else {
        console.log(form)
        // 体重预测值
        let result = form.gender==0 ?  (50 + (2.3 * (form.h*12/30.48 - 60))) : (45 + (2.3 * (form.h*12/30.48 - 60)))
        // 潮气量
        if(self.state){
          let vt = self.state == '1' ? self.targetVt1 * result : self.targetVt2 * result
          self.vt = String(vt.toFixed(0))
        }
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/PredictedBodyWeightARDS.vue